import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-h-small', 'LetterHSmall', [["path",{"d":"M10 16v-8"}],["path",{"d":"M14 8v8"}],["path",{"d":"M10 12h4"}]]);